<template>
  <div>
    <b-overlay
      id="overlay-background"
      :show="loader === true"
      variant="dark"
      opacity="0.85"
      blur="2px"
      rounded="sm"
      spinner-variant="primary"
      spinner-medium
    >
      <debtor-form />
    </b-overlay>
  </div>
</template>

<script>
import {
  BFormInvalidFeedback, BOverlay,
} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import { avatarText } from '@core/utils/filter'
import DebtorForm from './DebtorForm.vue'

export default {
  components: {
    BOverlay,
    DebtorForm,
  },
  setup() {
    const loader = ref(false)
    return {
      loader,
      avatarText,
      BFormInvalidFeedback,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
.spinner-border{
  width: 6rem;
  height: 6rem;
}
</style>
